<template>
    <div class="background" ref="ContactUs">
        <div class="logo-layer">

            <div class ="title">
                <p >OUR CUSTOMER</p>
            </div>
            
            <div class="logo-container">
                <div v-for="(logo, index) in logos" :key="index" class="logo">
                    <img :src="require(`@/assets/customerLogo/${logo}`)" alt="Customer Logo" />
                </div>
            </div>  

             
        </div>
        <div class="layer">
            <div class="title">
                <p>CONTACT US</p>
            </div>
            <div class = "container">
                <div class="photo_group">
                    <img src="../assets/qrcode.png" class="qrcode" />
                    <p class = "info-center">LeTimes乐港文化</p>
                </div>
                <div class="connect-info">
                    <p class = "info-text">DavidHan</p>
                    <p class = "info-text">Mobile: 13611390948</p>
                    <p class = "info-text">Email: david.han@le-times.com</p>
                    <p class = "info-text">Website: www.le-times.com</p>
                </div>
            </div>
            <div class="bottom">
                <a href="https://beian.miit.gov.cn/#/Integrated/index" class="info-center">网站备案号 : 京ICP备2024041811号-1</a>
            </div>
        </div>
            
    </div>
  </template>
  
  <script>
  export default {
    props: {
      selected: String,
    },
    data() {
      return {
        logos: [
            "1.png", "2.png", "3.png", "4.png", "5.png", "6.png",
            "7.png", "8.png", "9.png", "10.png", "11.png", "12.png",
            "13.png", "14.png", "15.png", "16.png", "17.png", "18.png"
        ]
      };
    },
    methods: {
       
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    
    .background{
        height: 100vh;
        width: 100vw;
        background: url(../assets/background.png) no-repeat center center;
        background-size: cover;
        z-index: -1; /* 确保背景位于内容之下 */
    }
    .logo-layer {
        background-color: rgba(0,0,0,0.0);
        display: flex;
        flex-direction: column;
        
        justify-content: center; /* 水平居中整个容器 */
        padding-bottom: 0px;
        top: 20%;
        align-items: center; 
        margin-top: 80px;
        height:calc(60vh - 80px);
        width: calc(100vw-80px);
        margin-left: 40px;
        margin-right: 40px;
    }
    .layer{
        background-color: rgba(0,0,0,0.5);
        height: 40vh;
        width: 100vw;
        padding-bottom: 0px;
        display: flex;
        flex-direction: column;
        padding:10px;
    }
    .logo-container {
        display: flex;
        width: calc(100vw - 256px);
        flex-wrap: wrap;      /* 自动换行 */
        padding : 40px;
    }

    .logo {
        flex: 0 0 calc(100% / 9); /* 每行 9 个元素 */
        text-align: center;       /* logo 居中显示 */
        padding: 4px;            /* 添加一些间距 */
    }

    .logo img {
        max-width: 100%;    /* 图片自适应容器宽度 */
        height: auto;       /* 保持图片比例 */
    }
    .container{
        padding:10px;
        display: flex;
        flex-direction: row;
        justify-content: center; /* 水平居中 */
        align-items: center;     /* 垂直居中 */
        margin-left: 64px;
    }
    .connect-info{
        margin-left: 32px;
        color: white;
        font-size: 1rem;
        font-family: Futura, Helvetica, Arial, sans-serif;
        display: flex;
        justify-content: left;
        flex-direction: column;
    }
    .photo_group{
        display: flex;
        flex-direction: column;
    }
    .info-center{
        color: white;
        font-size: 1rem;
        font-family: Futura, Helvetica, Arial, sans-serif;
    }
    .bottom{
        margin-top: 32px;
    }
    .title{
        color: white;
        font-family: Futura, Helvetica, Arial, sans-serif;
        text-align: center;
        font-size: 1.5rem;
        line-height: 3rem;
    }
    .info-text{
        line-height: 2rem;
        text-align: left;
    }
    .qrcode{
        height: 128px;
        width: 128px;
        margin: 16px;
    }
    @media (max-width: 768px) {
        .container{
            margin-left: 0px;
        }
        .connect-info{
            margin-left:0px;
        }
        .logo-container {
            display: flex;
            width: 80%;
            height:auto;
            flex-wrap: wrap;      /* 自动换行 */
            padding : 0px;
        }
        .logo {
            flex: 0 0 calc(100% / 3); /* 每行 3 个元素 */
            text-align: center;       /* logo 居中显示 */
            padding: 4px;            /* 添加一些间距 */
        }
        .logo-layer{
            top:10%;
        }

    }
    
    
  </style>
  